import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { leistungen } from "@/data/leistungen";
import { T } from "@/components/T";
import { useLanguage } from "@/contexts/LanguageContext";

export function LeistungenSection() {
  const { lang } = useLanguage();

  const kernLeistungen = [
    { ...leistungen[0], nutzen: { de: "Mehr Wohnraum ohne Neubau – schnell, leicht, präzise.", it: "Più spazio abitativo senza nuova costruzione – veloce, leggero, preciso." } },
    { ...leistungen[1], nutzen: { de: "Statisch sicher, handwerklich präzise, jahrzehntelang haltbar.", it: "Strutturalmente sicuro, artigianalmente preciso, duraturo per decenni." } },
    { ...leistungen[2], nutzen: { de: "Individuell geplant. Energieeffizient. Mit Charakter.", it: "Pianificato individualmente. Energeticamente efficiente. Con carattere." } },
    { ...leistungen[3], nutzen: { de: "Im laufenden Betrieb umbauen – mit minimalen Unterbrechungen.", it: "Ristrutturare durante l'attività – con interruzioni minime." } },
    { ...leistungen[4], nutzen: { de: "Das Gesicht des Gebäudes – langlebig und architektonisch stark.", it: "Il volto dell'edificio – duraturo e architettonicamente forte." } },
    { ...leistungen[5], nutzen: { de: "Bestand mit Zukunft – sinnvoller als abreißen und neu bauen.", it: "Patrimonio con futuro – più sensato che abbattere e ricostruire." } },
  ];

  const itTitles = ["Sopraelevazioni & Ampliamenti", "Capriate & Strutture in Legno", "Case in Legno", "Edilizia Alberghiera", "Facciate in Legno", "Risanamenti & Restauri"];

  return (
    <section data-testid="leistungen-section" className="section-gap bg-hb-off-white">
      <div className="container-hb">
        <div className="flex items-end justify-between mb-14">
          <div>
            <span className="label-text block mb-3 reveal"><T de="Was wir bauen" it="Cosa costruiamo" /></span>
            <h2 className="font-bebas text-hb-dark reveal reveal-delay-1" style={{ fontSize: "clamp(48px, 6.5vw, 88px)", lineHeight: 1 }}>
              <T de="Leistungen." it="Servizi." />
            </h2>
          </div>
          <Link to="/leistungen" data-testid="all-leistungen-link"
            className="text-[10px] tracking-widest uppercase text-hb-muted hover:text-hb-dark transition-colors font-inter flex items-center gap-2 reveal">
            <T de="Alle Leistungen" it="Tutti i servizi" /> <ArrowRight size={11} />
          </Link>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-7">
            <div className="border-t border-hb-border">
              {kernLeistungen.map((l, i) => (
                <Link key={l.id} to={`/leistungen/${l.slug}`} data-testid={`leistung-card-${l.id}`}
                  className={`leistung-row group reveal reveal-delay-${(i % 3) + 1}`}>
                  <span className="font-cormorant font-light w-12 flex-shrink-0 text-right leading-none group-hover:text-hb-yellow transition-colors duration-300"
                    style={{ fontSize: "clamp(28px, 3.5vw, 44px)", color: "rgba(245,200,0,0.28)" }}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-manrope font-bold text-hb-dark text-sm md:text-base group-hover:text-hb-yellow transition-colors duration-200 leading-tight">
                      {lang === "it" ? itTitles[i] : l.title}
                    </h3>
                    <p className="text-xs text-hb-muted font-inter mt-0.5 truncate">{l.nutzen[lang]}</p>
                  </div>
                  <ArrowRight size={14} className="leistung-arrow text-hb-muted flex-shrink-0 group-hover:text-hb-yellow transition-colors duration-200" />
                </Link>
              ))}
            </div>
            <div className="mt-10 reveal">
              <Link to="/anfrage" data-testid="leistungen-cta-btn" className="btn-primary">
                <T de="Projekt anfragen" it="Richiedi un progetto" />
              </Link>
            </div>
          </div>
          <div className="hidden lg:block lg:col-span-5">
            <div className="sticky top-28 space-y-2">
              <div className="overflow-hidden" style={{ height: "clamp(240px, 28vw, 360px)" }}>
                <img src="/assets/fotos/hb-foto-2-2.jpeg" alt="Holzfassade – Holzbuddy Südtirol"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" style={{ objectPosition: "center" }} />
              </div>
              <div className="overflow-hidden" style={{ height: "clamp(140px, 16vw, 200px)" }}>
                <img src="/assets/fotos/hb-foto-11.jpeg" alt="Moderne Holzkonstruktion – Holzbuddy"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" style={{ objectPosition: "center" }} />
              </div>
              <p className="text-[9px] tracking-widest uppercase text-hb-muted font-semibold font-inter pt-1">
                <T de="Ausführungsqualität · Holzbuddy Südtirol" it="Qualità di esecuzione · Holzbuddy Alto Adige" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
